
// List of allowed cities in Banjul and Western regions of The Gambia
const ALLOWED_ZONES = [
  // Banjul region
  'banjul',
  'bakau',
  'serrekunda',
  'kanifing',
  'sukuta',
  'bijilo',
  'kololi',
  'brufut',
  'tallinding',
  'latrikunda',
  'dippa kunda',
  'churchill\'s town',
  'pipeline',
  'london corner',
  'new jeshwang',
  'old jeshwang',
  'brusubi',
  'yundum',
  'tabokoto',
  'manjai',
  'bundung',
  'wellingara',
  'fajara',
  'kotu',
  'cape point',
  'bartez',
  'serekunda',
  'banjulinding',
  'lamin',
  'abuko',
  'brikama ba',
  'old yundum',
  'new yundum',
  
  // Western region
  'brikama',
  'gunjur',
  'tujereng',
  'sanyang',
  'tujering',
  'kafuta',
  'sibanor',
  'berending',
  'ghana town',
  'tanji',
  'brufut gardens',
  'mamut',
  'kalagi',
  'berending',
  'bonto',
  'kitty',
  'madina',
  'sanchaba',
  'after mile 7',
  'mile 7',
  'bafuloto',
  'soma',
  'gunjur kuta',
  'kartong',
  'after kartong',
  'jambur',
  'kampasa',
  'darsilami',
  'kembujeh',
  'fula bantang',
  'pirang',
  'jambanjelly',
  'after jambanjelly',
  'marakissa',
  'kembujeh',
  'manduar',
  'brikama nding',
  'after brikama',
  'kombo east',
  'kombo central',
  'kombo north',
  'kombo south'
];

export const isLocationInAllowedZone = (address: string, city?: string): boolean => {
  if (!address && !city) return false;
  
  const locationText = `${address} ${city || ''}`.toLowerCase();
  
  // Check if any of the allowed zones are mentioned in the location
  return ALLOWED_ZONES.some(zone => 
    locationText.includes(zone.toLowerCase()) ||
    locationText.includes(zone.toLowerCase().replace(/\s+/g, '')) ||
    // Also check for partial matches for compound names
    zone.toLowerCase().split(' ').some(part => 
      part.length > 3 && locationText.includes(part)
    )
  );
};

export const validateZoneForRestaurantAccess = (userLocation: string): { isAllowed: boolean; message?: string } => {
  const isAllowed = isLocationInAllowedZone(userLocation);
  
  if (!isAllowed) {
    return {
      isAllowed: false,
      message: 'Service is currently only available in Banjul and Western regions. Please check back later for expansion to your area.'
    };
  }
  
  return { isAllowed: true };
};
